import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import axios from "axios";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import { Form } from "react-bootstrap";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import $ from "jquery";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import { useHistory, Link } from "react-router-dom";
import Footer from "../../Footer";
// import { Link } from "react-router-dom";

export default function AddAdLession() {
  const { token } = isAutheticated();
  const tab1 = useRef(null);
  const tab2 = useRef(null);
  const [lession, setLession] = useState({
    madeBy: "",
    title: "",
    description: "",
    // subject: "",
    languageid: "",
    live: false,
    thumbnail: "",
    banner: "",
    launch: false,
    launchDate: new Date(),
    video: "",
  });
  const [loading, setLoading] = useState(false);
  const [Validation, setValidation] = useState(false);
  const [searchMovie, setSearchMovie] = useState("");
  const [movieList, setMovieList] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [formData, setFormData] = useState(new FormData());
  const [metaformData, setMetaformData] = useState({});
  const [validForm, setvalidForm] = useState(false);
  const [error, setError] = useState("");
  const [lessionId, setLessionId] = useState(null);
  const [success, setSuccess] = useState(false);
  const [currentTab, setcurrentTab] = useState(1);
  const [metaDataTitle, setmetaDataTitle] = useState("");
  const [metaDataPlot, setmetaDataPlot] = useState("");
  const [metaDataDirector, setmetaDataDirector] = useState("");
  const [metaDataWriter, setmetaDataWriter] = useState("");
  const [metaDataCrew, setmetaDataCrew] = useState([]);
  // var metaformData={}

  const wordLimit = {
    title: 50,
    description: 600,
  };

  const [titleLen, setTitleLen] = useState(wordLimit.title);
  const [descriptionLen, setDescriptionLen] = useState(wordLimit.description);

  const history = useHistory();

  useEffect(() => {
    const checkForm = () => {
      if (
        lession.title.length !== 0 &&
        // lession.banner != "" &&
        // lession.description.length != 0 &&
        // lession.languageid.length != 0 &&
        lession.thumbnail !== ""
        // lession.video != ""
        // lession.subject.length != 0
      ) {
        setError("");
        setvalidForm(true);
        console.log("true");
      } else {
        setError("All fields are must!");
        setvalidForm(false);
      }
    };
    checkForm();
  }, [lession]);

  useEffect(() => {
    // $("#summernote").summernote();
    axios
      .get(`${API}/api/languages`)
      .then((response) => {
        // console.log(response);
        setLanguages(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {
      setLanguages({});
    };
  }, []);

  const getVideoDuration = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const media = new Audio(reader.result);
        media.onloadedmetadata = () => resolve(media.duration);
      };
      reader.readAsDataURL(file);
      reader.onerror = (error) => reject(error);
    });

  const handleChange = async (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    formData.delete(name);

    if (name == "video") {
      /*Maximum allowed size in bytes
        5MB Example
        Change first operand(multiplier) for your needs*/
      const maxAllowedSize = 100 * 1024 * 1024;
      if (e.target.files[0]?.type !== "video/mp4") {
        e.target.value = "";
        swal({
          title: "Video should be of mp4 only",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      if (e.target.files[0].size > maxAllowedSize) {
        e.target.value = "";
        swal({
          title: "Your video file size must be less than 100mb",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      setLession({ ...lession, video: URL.createObjectURL(e.target.files[0]) });
      formData.set("video", e.target.files[0]);
      const duration = await getVideoDuration(e.target.files[0]);
      console.log(Number(duration).toFixed(2));
      formData.set("duration", Number(duration).toFixed(2));
    } else if (name == "thumbnail") {
      if (
        e.target.files[0]?.type === "image/jpeg" ||
        e.target.files[0]?.type === "image/png" ||
        e.target.files[0]?.type === "image/jpg"
      ) {
        setLession({
          ...lession,
          thumbnail: URL.createObjectURL(e.target.files[0]),
        });
        formData.set(name, e.target.files[0]);
        setValidation(false);
      } else {
        e.target.value = null;
        setValidation(true);
      }
    } else if (name == "banner") {
      setLession({
        ...lession,
        [name]: URL.createObjectURL(e.target.files[0]),
      });
      formData.set(name, e.target.files[0]);
    } else {
      setLession({ ...lession, [name]: value });
      formData.set(name, value);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {

      if (!lessionId) {
        return;
      }
      setLoading(true);
      console.log(formData.get("duration"));
      formData.delete("thumbnail");
      const responseVideo = await axios.post(
        `${API}/api/adlesson/${lessionId}/video`,
        formData,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/formdata",
          },
        }
      );
      // console.log(response);
      setLoading(false);
      // console.log(response);
      setSuccess(true);
      swal({
        title: "Video added successfully",
        icon: "success",
        button: "Return",
      }).then((v) => {
        history.push("/ad_video");
      });

    } catch (err) {
      console.log(err);
      console.log(err.response);
      setLoading(false);
      let message = err?.response?.data?.message;
      swal({
        title: "Error",
        text: message || "try again",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
      console.log(err);
    }
  };

  const onUpdatefirst = (e) => {
    e.preventDefault();
    setLoading(true);
    // setSuccess(false);
    formData.delete("video");
    axios
      .post(`${API}/api/adlesson/`, formData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        console.log("updated object", response);
        setLessionId(response.data.data._id);
        setLoading(false);
        // console.log(response);
        // setSuccess(!success);
        swal({
          title: "Changes are saved Successfully!",

          icon: "success",
          buttons: {
            SaveAndExit: {
              text: "Save and Exit",
              value: "SaveAndExit",
            },
            OkCancel: {
              text: "Save And Continue",
              value: "SaveAndContinue",
            },
          },
        }).then((value) => {
          switch (value) {
            case "SaveAndExit":
              history.push("/ad_video");
              break;
            case "SaveAndContinue":
              tab2.current.click();
              // history.push("/lessions");
              break;


            default:
              tab2.current.click();
          }
        });
      })
      .catch((err) => {
        setLoading(false);
        // setSuccess(!success);
        let message = "errror";
        swal({
          title: "Error",
          text: { message },
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
        console.log(err);
      });
  };


  const handleEdit = (e, type) => {
    const length = e.target.value.length;
    switch (type) {
      case "title":
        if (wordLimit.title - length !== -1) {
          handleChange(e);
          setTitleLen(wordLimit.title - length);
        }
        break;
      case "description":
        if (wordLimit.description - length !== -1) {
          handleChange(e);
          setDescriptionLen(wordLimit.description - length);
        }
        break;
      default:
        console.log("Incorrect Type");
    }
  };

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Advertisements</h4>
                {/* {console.log(subjects)} */}
                {/* {console.log(languages)} */}
                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Advertisemetns
                    </li>
                    <li className='breadcrumb-item'>Add New</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-md-12 col-lg-9 col-xl-8'>
                      <h1 className='text-left head-small'>Add New </h1>

                      <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className='nav-link active'
                            data-toggle='tab'
                            href='#title'
                            ref={tab1}
                            role='tab'>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/title-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Title</span>
                          </a>
                        </li>


                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className={`nav-link
                              ${validForm && success ? "" : ""}`}
                            data-toggle='tab'
                            href='#video'
                            role='tab'
                            onClick={() => {
                              setcurrentTab(2);
                            }}
                            ref={tab2}>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/video-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Video</span>
                          </a>
                        </li>

                      </ul>

                      <div className='tab-content video-tab px-3 pt-3 text-muted'>
                        <div
                          className='tab-pane active'
                          id='title'
                          role='tabpanel'>
                          <div className='panel-body px-3 pt-3'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Title*
                              </label>
                              <div className='col-md-8'>
                                <input
                                  onChange={(e) => handleEdit(e, "title")}
                                  type='text'
                                  className='form-control input-field'
                                  name='title'
                                  value={lession.title}
                                />
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining : {titleLen}
                                </p>
                              </div>
                            </div>

                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Description(optional)
                              </label>
                              <div className='col-md-8'>

                                <textarea
                                  onChange={(e) => handleEdit(e, "description")}
                                  value={lession.description}
                                  name='description'
                                  className='form-control input-field'
                                  rows='5'></textarea>
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining : {descriptionLen}
                                </p>
                              </div>
                            </div>




                            <div
                              className='tab-pane'
                              id='images'
                              role='tabpanel'>
                              <div className='panel-body'>
                                <div className='form-group mb-30 width-100 row'>
                                  <label className='col-md-4 control-label'>
                                    Upload Thumbnail Image*
                                    <br />
                                    <span className='size'>(320 x 180 px)</span>
                                  </label>
                                  <div className='col-md-8'>
                                    <span style={{ color: "red" }}>
                                      {Validation &&
                                        "Not a Valid Format for Thumbnails!"}
                                    </span>
                                    <input
                                      onChange={handleChange}
                                      name='thumbnail'
                                      type='file'
                                      className='form-control input-field'
                                      accept='image/png, image/jpg, image/jpeg'
                                    />
                                    <div>
                                      <img
                                        className='img-fluid mt-2'
                                        style={{
                                          height: "125px",
                                          width: "235px",
                                        }}
                                        alt='200x200'
                                        src={
                                          lession.thumbnail
                                            ? lession.thumbnail
                                            : "/lessionDefault.png"
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>


                                <div className='form-group mb-30 width-100 row'>
                                  <label className='col-md-4 control-label'></label>
                                  <div className='col-md-8'>
                                    <button
                                      onClick={onUpdatefirst}
                                      style={{ width: "120px" }}
                                      disabled={!validForm}
                                      type='button'
                                      className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                      <ClipLoader loading={loading} size={18} />
                                      {!loading && "Save"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>

                        {/* video panel */}
                        <div className='tab-pane' id='video' role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Upload Video*
                                <br />
                                <span className='size'>
                                  (mp4 file format only)
                                </span>
                              </label>
                              <div className='col-md-8'>
                                <input
                                  type='file'
                                  onChange={handleChange}
                                  name='video'
                                  accept='video/mp4,video/x-m4v,.mkv,video/*'
                                  className='form-control input-field mb-1'
                                />
                                <Player key={lession.video}>
                                  <source src={lession.video} />
                                </Player>
                                <small>File size must be less than 100mb</small>
                              </div>
                            </div>

                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 text-danger control-label'></label>
                              <div className='col-md-8'>
                                <button
                                  onClick={onSubmit}
                                  style={{ width: "120px" }}
                                  disabled={!lessionId}
                                  type='button'
                                  className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                      <div className='form-group row '>
                        <div className='col-md-4'></div>
                        <div className='col-md-8 text-left pl-3'>
                          <div className='form-group width-100'>
                            <span className='text-danger'>{error}</span>
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
